import userApi from '../api/user.api.js';
import smsApi from '../api/sms.api.js';
import util from '../store/utils';
import ActionApi from '../api/action.api.js'

export default {
    //用户登录
    async loginUser({commit, state}, params) {
        let data = await userApi.getToken(params.data.phone, params.data.password);
        data.icon = data.icon || state.user.icon;
        commit('setUser', data);
        return data;
    },
    //登录验证
    async loginVerify({dispatch, commit, state}, params) {
        let data = await userApi.login(params);
        commit('setUser', data);
        //如果是新用户则跳转到性别选择窗口
        if (data.newCommer) {
            commit('setNewCommer', true);
            commit('setLoginStep', 'sex');
        } else {
            await dispatch('loginUser', {data: {phone: data.phone, password: data.password}});
        }
        return data;
    },
    //注册用户
    registerUser({state, commit, dispatch}, company) {
        let params = {
            user: state.user,
            id:window.sessionStorage.getItem('id')||'',
            company
        };
        return userApi.register(params).then(data => {
            return dispatch('loginUser', {data: {phone: data.phone, password: data.password}}).then(user => {
                commit('setUser', user);
                return user;
            })
        })
    },
    //退出登录
    logoutUser({commit}) {
        commit('setUser', {
            icon: ''
        });
        util.runAuth('del');
        window.localStorage.user = null;
    },
    //验证登录，未登录淡出登录框
    verifyStepLogin({state, commit}) {
        if (state.user && state.user._id) {
            return Promise.resolve(true);
        } else {
            commit('setLoginStepLogin');
            return Promise.reject('请先登录');
        }
    },
    //验证当前用户是否有正在检测的网站
    isUserCheck({state}) {
        return userApi.isUserCheck(state.user._id);
    },
    //取消当前用户下检测的网站
    cancelCheck({state}) {
        return userApi.cancelCheck(state.user._id);
    },
    saveUser({commit, state}, params) {
        return userApi.save(params).then(data => {
            data.icon = data.icon || state.user.icon;
            commit('setUserInfo', data);
            return data;
        })
    },

    resetPassword(context, params) {
        return userApi.resetPassword({
            data: {
                _id: context.state.user._id,
                oldPassword: params.oldPassword,
                password: params.password
            }
        });
    },

    //手机验证码
    sendPhoneCode(context, params) {
        return smsApi.sendPhoneCode(params);
    },
    // 获取用户信息
    getUser(context) {
        return userApi.getUser(context.state.user._id).then((user) => {
            context.commit('setUser', user);
            return user;
        });
    },
    //是否在用户白名单内
    hasUserWhite({}, phone) {
        return userApi.hasUserWhite(phone);
    },
    // 提交在线反馈
    postFeedback({}, params) {
        return userApi.postFeedback(params);
    },
    //提交记录用户行为
    /*详细注释请看schema
    * category:'',    //在线学习、课程
    * action:'',    //用户跟目标交互的行为，如”播放”、”暂停”、”下载”、“点击”等等。该项必选
    * optLabel:'',    //课程名称
    * optValue:'',   //课程id
    * desc:'',     //描述
    * userId:'',    //事件发起人ID
    */

    postActionLog({},params){
        return ActionApi.asyncUpdate(params);
    },


};



// WEBPACK FOOTER //
// ./app/store/actions.js